module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/pre-approval.png";